// extracted by mini-css-extract-plugin
export default {"btnTransparent":"miDvAcwB","btnFull":"f8zBSad4","white":"kGxPR5l5","grey":"di_H9fa6","loading":"ThLkMPsT"};